import { render, staticRenderFns } from "./printRecord.vue?vue&type=template&id=130c497f&scoped=true"
import script from "./printRecord.vue?vue&type=script&lang=js"
export * from "./printRecord.vue?vue&type=script&lang=js"
import style0 from "./printRecord.vue?vue&type=style&index=0&id=130c497f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130c497f",
  null
  
)

export default component.exports